/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Readiness_NeutralInputs */

const en_ui_readiness_neutral = /** @type {(inputs: Ui_Readiness_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutral`)
};

const de_ui_readiness_neutral = /** @type {(inputs: Ui_Readiness_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neutral`)
};

/**
* | output |
* | --- |
* | "Neutral" |
*
* @param {Ui_Readiness_NeutralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_readiness_neutral = /** @type {((inputs?: Ui_Readiness_NeutralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Readiness_NeutralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_readiness_neutral(inputs)
	return de_ui_readiness_neutral(inputs)
});